import { ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { ParticipantManager } from '../../canvas/participants/ParticipantManager';
import { DropZone, DropZoneMode, DropZoneUser } from './DropZone';

export class DropZoneMechanics extends ActiveObject {

    @resolve(ObjectManager) private objects: ObjectManager;
    @resolve(ParticipantManager) private participants: ParticipantManager;

    public start() {
        this.burden(
            this.objects.on('DropZone', 'affected', ([x]) => this.syncAttachedUser(x.cast(DropZone))),
            this.objects.createTrigger('DropZone.OnRemove')
                .for(DropZone)
                .onChildAdded()
                .onChildRemoved()
                .doForEach(x => this.setAttachedUser(x)));

        this.objects.getAll(DropZone)
            .forEach(x => this.syncAttachedUser(x));
    }

    private setAttachedUser(zone: DropZone) {
        if (!zone.alive) return;
        // Trigger so running in an update
        if (zone.mode === DropZoneMode.participant) {
            const userId = zone.getPhysicalsNaturallyOrdered()
                .find(x => x.has('userId') && !!x.get('userId'))
                ?.get('userId') ?? null;

            if (zone.userId !== userId) {
                zone.userId = userId;
            }
        }
        else {
            if (zone.userId) {
                zone.userId = null;
            }
        }
    }

    private syncAttachedUser(zone: DropZone) {
        if (!zone.alive) return;
        if (zone.mode === DropZoneMode.participant && !!zone.userId) {
            const ptpt = this.participants.get(zone.userId);
            DropZoneUser.setMaybe(zone, ptpt);
        }
        else {
            DropZoneUser.setMaybe(zone, null);
        }
    }
}
